export default __webpack_public_path__ + "static/media/gallery38.d3abd39c.webp";